module.exports = __webpack_public_path__ + "img/onlineshop.383db1bf.svg";